exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-card[data-v-23f9548e]{background:#fff;border-radius:16px;-webkit-box-shadow:0 2px 12px rgba(0,0,0,.08);box-shadow:0 2px 12px rgba(0,0,0,.08);margin-bottom:14px;overflow:hidden}.card-header[data-v-23f9548e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 16px;border-top:3px solid transparent}.card-header.green-bar[data-v-23f9548e]{border-top-color:#10b981;background:#fafafa}.card-body[data-v-23f9548e]{padding:14px 16px 4px}", ""]);

// exports
